import { observer } from 'mobx-react-lite'
import { UiContactsTrigger } from 'pages/broadcasts/ui/BroadcastView/ui/ContactsContent/ui/UiContactsTrigger'
import { useBroadcastViewContext } from 'pages/broadcasts/ui/BroadcastView/context/broadcastViewContext'

export const ContactsTrigger = observer(() => {
  const { broadcastContactsStore, errorsMap, setError } = useBroadcastViewContext()
  const { editEnrollment, skipped, allTotal, loading, showZeroState, invalidBreakdown } =
    broadcastContactsStore

  const error = errorsMap.get('contacts')

  const handleClick = () => {
    if (loading) return

    setError('contacts', '')
    editEnrollment()
  }

  return (
    <UiContactsTrigger
      onClick={handleClick}
      total={allTotal}
      skipped={skipped}
      invalidBreakdown={invalidBreakdown}
      error={error}
      loading={loading}
      showZeroState={showZeroState}
    />
  )
})
